import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'has_the_fac_made_accommodationsarrangements_for_physically_disa'

export const dataPointDefinition = {
  retracedId: 'has_the_fac_made_accommodationsarrangements_for_physically_disa',
  name: 'Has the facility made accommodations/arrangements for physically disabled persons?',
  description:
    'The intent of this question is to understand if the facility has made any types of special accommodations/ arrangements for physically disabled persons. \r\r\n\r\r\nAccommodations/ arrangements may include installing ramps, redesigning workspaces, providing sit-lean stools, anti-fatigue matting, ergonomic accommodations, vacuum lifts, pallet server, forklifts, dollies etc. \r\r\n\r\r\nThis is regardless of whether physically disabled persons are or were at the facility. Therefore, there is no Not Applicable answer option.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'disc-9',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 11390,
  sectionId: '2.2.5',
  impactArea: 'Discrimination, Violence or Harassment',
  impactAreaId: 'DISCRIMINATION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
